import { TRANSACTION_TYPE, TRANSACTION_TYPE_PERSON_TO_PERSON } from 'consts';

// eslint-disable-next-line import/prefer-default-export
export const addRequiredFields = (r) => {
  r[TRANSACTION_TYPE] = TRANSACTION_TYPE_PERSON_TO_PERSON;

  return r;
};
